import React from 'react';
import PropTypes from 'prop-types';

import { ProgressRing } from '@techchange/components';

import './CompletionTracker.scss';

const propTypes = {

	/**
	 * The status for the completion tracker.
	 */
	status: PropTypes.oneOf(['in-progress', 'complete', 'not-started', 'error']),

	/**
	 * The progress percentage for the completion tracker.
	 */
	progress: PropTypes.number,

};

const chooseIcon = (status, progress) => {

	// Check if an invalid progress percentage was provided (or just missing entirely)
	let hideProgress = isNaN(parseFloat(progress));

	let code;

	switch (status) {
	case 'in-progress':

		code = 'fas fa-adjust';
		break;

	case 'complete':

		code = 'fas fa-check-circle';
		hideProgress = true;
		break;

	case 'error':

		code = 'fas fa-exclamation-circle';
		hideProgress = true;
		break;

	default:
		code = 'far fa-circle';
	}

	// Check if we need to show the exact progress percentage value for the completion tracker...
	if (!hideProgress) {

		return (
			<ProgressRing
				width={14}
				stroke={3}
				progress={progress}
				animate />
		);

	}

	// Otherwise, we'll show an approximation of the status for the completion tracker...
	return <i className={`${code}`}></i>;

};

const Tracker = ({ status, progress }) => {
	return (
		<div className={`tracker ${status || ''}`}>
			{chooseIcon(status, progress)}
		</div>
	);
};

Tracker.propTypes = propTypes;

export default Tracker;
